import { render, staticRenderFns } from "./ApproveTeacherEnroll.vue?vue&type=template&id=24d2275e&scoped=true"
import script from "./ApproveTeacherEnroll.vue?vue&type=script&lang=js"
export * from "./ApproveTeacherEnroll.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ApproveTeacherEnroll.vue?vue&type=style&index=1&id=24d2275e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2275e",
  null
  
)

export default component.exports